export default function bind_video_players(){


    const inlineVideo = document.querySelectorAll('video, .lazy-vid');


    const loadVideo = (video) => {
        const src = video.dataset.src;


        if(src){

            const videoContainer = video.closest('.video-wrap');
            let assetWrap = video.closest('.project-asset');

            if(!assetWrap){
                assetWrap = videoContainer;
            }

            if(assetWrap){

                let muted = 1;
                video.src = src;
          
                const controls = assetWrap.querySelector('.controls');

                let played = false;
                let videoLength = 0;
                const mousedown = false;

                if(controls){
                    const sound = controls.querySelector('.sound');
                    const size = controls.querySelector('.size');
                    const state = controls.querySelector('.state');

                    const pLeft = controls.querySelector('.play-bar-left');
                    const pRight = controls.querySelector('.play-bar-right');
                    const pTime = controls.querySelector('.play-time');
              
                    addClassOnHoverWithReset(videoContainer, 'show-controls', 2500);
              

                    window.players.push({
                        type: 'native',
                        player: video,
                        elm: videoContainer
                    });

                    if(typeof sound !== 'undefined'){
                        sound.addEventListener('click', function(){
                            if(muted){
                                muteAll();
                                muted = 0;
                                video.volume = 1;
                                videoContainer.classList.remove('muted');
                            }else{
                                muted = 1;
                                video.volume = 0;
                                videoContainer.classList.add('muted');
                            }
                        });
                    }


                    if(typeof size !== 'undefined'){

                        size.addEventListener('click', function(){

                            if(!window.fullscreen){
                                window.fullscreen = 1;
                                videoContainer.requestFullscreen();
                            }else{
                                window.fullscreen = 0;
                                document.exitFullscreen();
                            }
                        });
                        
                        videoContainer.addEventListener('fullscreenchange', () => {
                            if (document.fullscreenElement) {
                                videoContainer.classList.add('fullscreen');
                            } else {
                                videoContainer.classList.remove('fullscreen');
                            }
                        });
                        

                    }


                    video.addEventListener('play', function() {
                    
                        if(!mousedown){
                    
                            videoContainer.parentNode.classList.add('playing');
                            videoContainer.parentNode.classList.add('embed-loaded');

                            const assetWrap = videoContainer.closest('.project-asset');
                            if(assetWrap){
                                assetWrap.classList.add('loaded');
                            }
                            
                            state.innerHTML = 'Pause';
                            videoLength = video.duration;

                            
                        }

                    });
                

                    video.addEventListener('timeupdate', function() {
                        // console.log('Current time: ' + video.currentTime);
                        const per =  (video.currentTime/video.duration) * 100;
                        
                        pLeft.style.setProperty("--width", per + '%');
                        pRight.style.setProperty("--width", 100-per + '%');
                        pTime.innerHTML = convertToFilmTimestamp(video.currentTime);
                        videoContainer.dataset.time = video.currentTime;

                        if(video.volume < 1){
                            muted = 1;
                        }

                    });

                } else {
                    
                    video.addEventListener('play', function() {
                        played = true;
                    });

                }
        
                
                const onScreen = (entries, _observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if(played){
                                video.play();
                            }
                        }else{
                            if(played){
                                video.pause();
                                // console.log('pause');
                            }
                        }
                    });
                };
    
                const screen_observer = new IntersectionObserver(onScreen, {
                    rootMargin: "100px 100px",
                    threshold: 0.1
                });
            
                if(!videoContainer.classList.contains('hover-vid')){
                    screen_observer.observe(videoContainer);
                }

                if(videoContainer.classList.contains('hover-vid')){
                
                    const link = videoContainer.closest('.project-link');
       
                    if(link){
                        link.addEventListener('mouseenter', function(){
                            video.play();
                        });
                        link.addEventListener('mouseleave', function(){
                            video.pause();
                        });
                    }
                }
            

                video.addEventListener('canplay', function() {
        
                    video.classList.remove('lazy-vid');
                    videoContainer.classList.add('embed-loaded');
                
                    if(assetWrap){
                        assetWrap.classList.add('loaded');
                    }

                    videoLength = video.duration;
                    video.play();

                });
                

            }
        }
       
    };


    const lazyLoad = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {

                const clientBox =  entry.target.closest('.client-box');
                const project =  entry.target.closest('.video-wrap');

                if(project && clientBox){
                   
                    if(project.classList.contains('top')){

                        loadVideo(entry.target);
                        observer.unobserve(entry.target);

                    }

                }else{
                    loadVideo(entry.target);
                    observer.unobserve(entry.target);
                }
            }
        });
    };


    const observer = new IntersectionObserver(lazyLoad, {
        rootMargin: "300px 1000px",
        threshold: 0.1
    });


    inlineVideo.forEach(video => {
        video.classList.add('bound');
        observer.observe(video);
    });

    // Watch the document for newly-injected <video> / .lazy-vid nodes (e.g. via
    // AJAX page loads) and bind them just-in-time. Replaces a 1Hz polling
    // setTimeout chain that previously kept multiplying on every nav.
    if (!window.__videoBindObserver) {
        const bindIfVideo = (node) => {
            if (!(node instanceof HTMLElement)) return;
            if ((node.matches && node.matches('video, .lazy-vid')) && !node.classList.contains('bound')) {
                node.classList.add('bound');
                observer.observe(node);
            }
            // Also check descendants
            if (node.querySelectorAll) {
                node.querySelectorAll('video:not(.bound), .lazy-vid:not(.bound)').forEach((v) => {
                    v.classList.add('bound');
                    observer.observe(v);
                });
            }
        };
        const mo = new MutationObserver((mutations) => {
            mutations.forEach((m) => m.addedNodes.forEach(bindIfVideo));
        });
        mo.observe(document.body, { childList: true, subtree: true });
        window.__videoBindObserver = mo;
    }
}


function convertToFilmTimestamp(seconds) {
    // Convert the float to total seconds
    const totalSeconds = Math.floor(seconds);
    
    // Calculate hours, minutes, and seconds
    let hours = Math.floor(totalSeconds / 3600);
    let minutes = Math.floor((totalSeconds % 3600) / 60);
    let secs = totalSeconds % 60;

    // Pad with leading zeros if necessary
    hours = String(hours).padStart(2, '0');
    minutes = String(minutes).padStart(2, '0');
    secs = String(secs).padStart(2, '0');

    // Return the formatted timestamp
    return `${hours}:${minutes}:${secs}`;
}


function addClassOnHoverWithReset(element, className, delay) {
    let timeout;

    function removeClass() {
      element.classList.remove(className);
    }

    function resetTimer() {
      element.classList.add(className);
      clearTimeout(timeout);
      timeout = setTimeout(removeClass, delay);
    }

    element.addEventListener('mouseenter', () => {
      element.classList.add(className);
      resetTimer();
    });

    element.addEventListener('touchstart', () => {
        element.classList.add(className);
        resetTimer();
      });

    element.addEventListener('mousemove', resetTimer);
    element.addEventListener('touchmove', resetTimer);

    element.addEventListener('mouseleave', () => {
      clearTimeout(timeout);
      removeClass();
    });

    element.addEventListener('touchend', () => {
        clearTimeout(timeout);
        removeClass();
      });
  
  }

  function muteAll(){
    
    for (let a = 0; a < window.players.length; a++) {
        const player =  window.players[a];

        if(player.type === 'vim'){
            player.player.setVolume(0);
        }else{
            player.player.volume = 0;
        }

        player.elm.classList.add('muted');
        
    }
    
  }